export enum ProductTag {
  DAMA = "DAMA",
  HOMBRE = "HOMBRE",
  UNISEX = "UNISEX",
  LIQUIDACION = "LIQUIDACIÓN",
  PREMIUM = "PREMIUM",
  WEB = "Web",
  HOT_SALE = "Hot Sale",
  CYBER_MONDAY = "Cyber Monday",
  TALLE = "Talle", //  use .includes() to check if the type is a size, it is not complete name, because it should be "Talle x" where x is the size
  COLOR = "Color", // use .includes() to check if the type is a color, it is not complete name, because it should be "Color x" where x is the color
}

export enum PaywayId {
  NONE = 0,
  CASH = 1,
  TRANSFER = 3,
  CARD = 5,
}

export enum ShippingTypeId {
  NONE = 0,
  CADETE = 1,
  BRANCH_PICKUP = 2,
  CORREO_ARGENTINO = 3,
  COURIER_SHIPPING = 5,
}

export enum WholesaleStatus {
  WHOLESALE = 1,
  RESELLER = 2,
}

export enum InvoiceTypeId {
  CONSUMIDOR_FINAL = 6,
}
